import Icon from '../components/Icon.vue'

Icon.register({"dolly-flatbed":{"width":640,"height":512,"paths":[{"d":"M208 320H592C600.8 320 608 312.8 608 304V48C608 39.2 600.8 32 592 32H448V160L400 128 352 160V32H208C199.2 32 192 39.2 192 48V304C192 312.8 199.2 320 208 320zM624 384H128V16C128 7.2 120.8 0 112 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H64V432C64 440.8 71.2 448 80 448H162.9C161.1 453 160 458.4 160 464 160 490.5 181.5 512 208 512S256 490.5 256 464C256 458.4 254.8 453 253.1 448H451C449.2 453 448.1 458.4 448.1 464 448.1 490.5 469.6 512 496.1 512S544.1 490.5 544.1 464C544.1 458.4 542.9 453 541.2 448H624C632.8 448 640 440.8 640 432V400C640 391.2 632.8 384 624 384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dolly-flatbed.js
// module id = G2lz
// module chunks = 0